import { Field, ObjectType } from "./decorators";

@ObjectType()
export class EventLog {
    @Field() eventLogId!: number;
    @Field() trackingNumber?: string;
    @Field() eventName!: string;
    @Field() createTime!: Date;
    @Field() updatedBy?: string;
    @Field() accountId?: number;
    @Field() company?: string;
    @Field() newAccountId?: number;
    @Field() newCompany?: string;
    @Field() scId?: number;
    @Field() origOrderId?: number;
    @Field() origApplicationType?: string;
    @Field() origLeaseStatus?: string;
    @Field() origStartDate?: Date;
    @Field() origEndDate?: Date;
    @Field() origScExpirationDate?: Date;
    @Field() origTerm?: number;
    @Field() origAmount?: number;
    @Field() origPaymentReceivedDate?: Date;
    @Field() origPaymentMethod?: string;
    @Field() origSalesOrderId?: string;
    @Field() origSalesOrderInternalId?: string;
    @Field() newSalesOrderId?: string;
    @Field() newOrderId?: number;
    @Field() adjEndDate?: Date;
    @Field() adjScExpirationDate?: Date;
    @Field() adjTerm?: number;
    @Field() adjAmount?: number;
    @Field() creditAmount?: number;
    @Field() comments?: string;
    @Field() nsRequestTime?: Date;
    @Field() nsResponseStatus?: string;
    @Field() nsFailureReason?: string;

    // local additions
    formattedCreditAmount?: string | null;
}
